const HOME_PAGE_COPY = {
  en: {
    notice: { title: 'Latest updates', viewAll: 'View all announcements', empty: 'No announcements yet.' },
    market: {
      title: 'Explore crypto assets', description: 'Follow live prices, spot the movers and find your next opportunity.', view: 'Market view',
      tabs: { popular: 'Popular', gainers: 'Top gainers', losers: 'Top losers' }, viewAll: 'View all markets',
      noPriceChanges: 'No price changes to show yet. Try another view.', dataPending: 'Market data will appear when prices connect.'
    },
    features: {
      sectionTitle: 'Explore the FTZINC ecosystem',
      trade: { title: 'Trade Seamlessly', description: 'Swap tokens across multiple chains with low fees and best rates.' },
      earn: { title: 'Earn Rewards', description: 'Stake, farm and earn passive income with FTZINC.' },
      play: { title: 'Explore & Play', description: 'Fun Web3 games and quests. Play, earn and level up!' },
      build: { title: 'Build & Deploy', description: 'Tools and infrastructure to build the future on FTZINC.' },
      secure: { title: 'Secure & Simple', description: 'Top-tier security with a user experience made for everyone.' }
    },
    ecosystem: {
      title: 'The FTZINC Ecosystem', allProducts: 'All Products', products: {
        wallet: { title: 'FTZINC Wallet', description: 'Your gateway to Web3.' },
        swap: { title: 'FTZINC Swap', description: 'Cross-chain swaps made easy.' },
        earn: { title: 'FTZINC Earn', description: 'Maximize your crypto earnings.' },
        launchpad: { title: 'FTZINC Launchpad', description: 'Discover and launch the next big things.' },
        commodities: { title: 'FTZINC Commodities', description: 'Explore energy, metals and other global commodities.' },
        indices: { title: 'FTZINC Indices', description: 'Track major market indices and trade with confidence.' }
      }
    },
    learn: {
      title: 'Learn, Grow, Stay Ahead.', viewAll: 'View all articles', articles: {
        web3: { category: 'Basics', title: 'What is Web3?', description: "A beginner's guide to the future of the internet." },
        stake: { category: 'Guides', title: 'How to Stake NEX', description: 'Step-by-step guide to start earning with FTZINC.' },
        security: { category: 'Security', title: 'Stay Safe in Web3', description: 'Essential tips to protect your assets.' },
        chain: { category: 'Ecosystem', title: 'FTZINC Chain Explained', description: 'Built for speed, scale and the future.' }
      }
    },
    voices: {
      title: 'Voices from the Community',
      chris: 'FTZINC makes Web3 simple and fun. The UI is clear and the team is awesome.',
      diana: 'I have tried many platforms, but FTZINC is the real deal. Fast, secure and easy.',
      wolf: 'The ecosystem has everything I need in one place. I love it!',
      mia: 'FTZINC games are addictive. Earning while having fun is the best.',
      dan: 'Building on FTZINC Chain was so smooth. Great tools and support!'
    }
  },
  tc: {
    notice: { title: '最新消息', viewAll: '查看全部公告', empty: '目前沒有公告。' },
    market: {
      title: '探索加密資產', description: '追蹤即時價格、掌握市場動向，尋找下一個機會。', view: '市場檢視',
      tabs: { popular: '熱門', gainers: '漲幅排行', losers: '跌幅排行' }, viewAll: '查看所有市場',
      noPriceChanges: '目前沒有可顯示的價格變化，請嘗試其他檢視。', dataPending: '連接價格後將顯示市場資料。'
    },
    features: {
      sectionTitle: '探索 FTZINC 生態系',
      trade: { title: '暢享順暢交易', description: '以低手續費和最佳匯率，在多條鏈之間兌換代幣。' },
      earn: { title: '賺取獎勵', description: '使用 FTZINC 進行質押、流動性挖礦，賺取被動收益。' },
      play: { title: '探索與遊玩', description: '好玩的 Web3 遊戲與任務。遊玩、賺取收益並升級！' },
      build: { title: '建構與部署', description: '在 FTZINC 上打造未來所需的工具與基礎設施。' },
      secure: { title: '安全又簡單', description: '頂級安全防護，搭配為每個人打造的使用體驗。' }
    },
    ecosystem: {
      title: 'FTZINC 生態系', allProducts: '所有產品', products: {
        wallet: { title: 'FTZINC 錢包', description: '通往 Web3 的入口。' },
        swap: { title: 'FTZINC Swap', description: '跨鏈兌換變得簡單。' },
        earn: { title: 'FTZINC Earn', description: '最大化您的加密資產收益。' },
        launchpad: { title: 'FTZINC Launchpad', description: '發掘並推出下一個熱門項目。' },
        commodities: { title: 'FTZINC 大宗商品', description: '探索能源、金屬及其他全球大宗商品市場。' },
        indices: { title: 'FTZINC 指數', description: '追蹤主要市場指數，安心掌握交易機會。' }
      }
    },
    learn: {
      title: '學習、成長、保持領先。', viewAll: '查看所有文章', articles: {
        web3: { category: '基礎知識', title: '什麼是 Web3？', description: '帶您認識網際網路未來的入門指南。' },
        stake: { category: '指南', title: '如何質押 NEX', description: '開始透過 FTZINC 賺取收益的步驟指南。' },
        security: { category: '安全', title: '安全使用 Web3', description: '保護您資產的重要提醒。' },
        chain: { category: '生態系', title: 'FTZINC Chain 詳解', description: '為速度、擴展性與未來而打造。' }
      }
    },
    voices: {
      title: '來自社群的聲音',
      chris: 'FTZINC 讓 Web3 變得簡單又有趣。介面清晰，團隊也很棒。',
      diana: '我試過許多平台，但 FTZINC 真的很出色。快速、安全又簡單。',
      wolf: '這個生態系把我需要的一切都集中在一起，我很喜歡！',
      mia: 'FTZINC 的遊戲令人著迷，一邊玩樂一邊賺取收益最棒了。',
      dan: '在 FTZINC Chain 上建構非常順暢，工具和支援都很出色！'
    }
  }
}

export function getHomePageCopy(locale = 'en') {
  return HOME_PAGE_COPY[locale] || HOME_PAGE_COPY.en
}
